import "core-js/modules/es.number.constructor.js";
export default {
  name: "DataSourceTag",
  props: {
    type: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "mini"
    },
    zoom: {
      type: Number
    }
  },
  computed: {
    source: function source() {
      if (this.type === "CMB") {
        return "招商银行";
      } else if (this.type === "ALIPAY") {
        return "支付宝";
      }
      return "";
    }
  }
};